import { PolymerElement, html } from '@polymer/polymer';
import { KatapultEditorTemplate } from './katapult-editor-template';

import '../paper-table/paper-table.js';
import '../k-logic-editor/k-logic-editor.js';
import '../confirm-dialog/confirm-dialog';

import { LazySet } from '../../modules/LazySet.js';

import '../style-modules/paper-table-style';
import '../style-modules/flex';
import '../style-modules/katapult-scrollbars';
import { DEFAULT_SCHEMAS, PPL_SCHEMAS } from '../../modules/KLogicSchemas.js';
import '../katapult-elements/katapult-button.js';

class KatapultQualityControlEditor extends KatapultEditorTemplate {
  static get template() {
    return html`
      ${super.style}
      <style include="flex paper-table-style katapult-scrollbars">
        paper-tabs {
          --paper-tabs-selection-bar-color: var(--secondary-color);
          --paper-tab-ink: var(--secondary-color);
        }
        paper-tabs {
          --paper-tabs-content: {
            display: flex;
            min-width: 100%;
          };
        }
      </style>

      <!-- todo: check that icons loaded (custom katapult icons) -->
      <!-- todo: add missing styles -->
      <!-- todo: removes instances of "step" -->
      <katapult-firebase-worker
        id="warningModulesFirebaseWorker"
        path="[[modelSpaceDetails.path]]/models/quality_control_custom_modules"
        data="{{customModules}}"
      >
      </katapult-firebase-worker>
      <template is="dom-repeat" items="[[steps]]" as="step">
        <katapult-editor-step
          step$="[[step.id]]"
          creating-item="[[creatingItem]]"
          active="[[step.active]]"
          index="[[step.index]]"
          current-index="[[currentIndex]]"
          title="[[step.title]]"
        >
          <template is="dom-if" if="[[equal(step.id, 'logic_editor')]]" restamp>
            <paper-table style="overflow: hidden; flex-grow: 3;" rounded white outline slot="body">
              <paper-row raised-on-scroll grey>
                <paper-cell icon><iron-icon icon="icons:swap-vert"></iron-icon></paper-cell>
                <paper-tabs style="flex-grow:2" selected="{{selectedTableIndex}}" scrollable>
                  <paper-tab>Warning</paper-tab>
                  <paper-tab>Warning Variables</paper-tab>
                </paper-tabs>
                <paper-cell icon-button on-click="toggleExpandAll"
                  ><katapult-button iconOnly noBorder icon="unfold_more"></katapult-button
                ></paper-cell>
                <paper-cell icon></paper-cell>
              </paper-row>

              <paper-table-scroll on-sort-changed="warningsArraySorted">
                <template is="dom-if" if="[[equal(selectedTableIndex, 0)]]">
                  <!-- No Warnings -->
                  <template is="dom-if" if="[[!warningsCount]]">
                    <paper-row slot="before">
                      <paper-cell center style="color: var(--paper-grey-600);">
                        <iron-icon icon="katapult-misc:search-off"></iron-icon>
                        <span>No Warnings Yet</span>
                      </paper-cell>
                    </paper-row>
                  </template>
                  <template is="dom-repeat" items="{{warningsArray}}" index-as="warningIndex" rendered-item-count="{{warningsCount}}">
                    <paper-header-content
                      white
                      opened="{{item.$opened}}"
                      no-click-row
                      slot="sortable"
                      divider
                      data-path="warningsArray.$(model.warningIndex).$rendered"
                      data-value="$true"
                      on-opened-changed="updateProperty"
                    >
                      <!--HEADER ROW-->
                      <paper-cell drag-handle icon slot="header">
                        <span>[[item.order]]</span>
                      </paper-cell>
                      <paper-cell slot="header">
                        <paper-input label="Warning Text" value="{{item.warning_text}}" no-label-float></paper-input>
                      </paper-cell>
                      <paper-cell icon-button slot="header-end" on-click="duplicateWarning">
                        <katapult-button iconOnly noBorder icon="content_copy"></katapult-button>
                      </paper-cell>
                      <paper-cell icon-button slot="header-end" on-click="deleteWarning">
                        <katapult-button iconOnly noBorder icon="delete"></katapult-button>
                      </paper-cell>

                      <!--CONTENT ROW-->
                      <div style="background: var(--paper-grey-50); padding: 24px;" slot="content">
                        <template is="dom-if" if="[[item.$rendered]]">
                          <div flex column style="gap: 24px;">
                            <!-- Entrypoint -->
                            <div flex column style="gap: 8px;">
                              <div flex align-center style="gap: 8px;">
                                <material-icon icon="input"></material-icon>
                                <div style="font-size: 16px; font-weight: 500;">Warning Type</div>
                              </div>
                              <div>What part of a job (entity type) does this warning apply to?</div>
                              <katapult-drop-down
                                items="[[entrypointsList]]"
                                label-path="label"
                                value-path="name"
                                label="Applies to"
                                style="width: fit-content;"
                                no-label-float
                                sort="[[sortByOrder]]"
                                value="[[item.entrypoint]]"
                                data-path="warningsArray.$(model.warningIndex).entrypoint"
                                on-selected-changed="updateProperty"
                              ></katapult-drop-down>
                            </div>

                            <!-- Filter -->
                            <div flex column style="gap: 8px;">
                              <div flex align-center style="gap: 8px;">
                                <material-icon icon="filter_alt"></material-icon>
                                <div style="font-size: 16px; font-weight: 500;">Filter</div>
                              </div>
                              <div>
                                Optional: If this check only applies to some of the entities selected above, add a filter condition here.
                              </div>
                              <k-logic-editor
                                schema="[[computeSchema(item.entrypoint)]]"
                                k-logic-type="[[getKLogicTypeForItem(item, warningsArray.*)]]"
                                debug-reference-data="[[debugReferenceData]]"
                                block="{{item.filter}}"
                              ></k-logic-editor>
                            </div>

                            <!-- QC Check -->
                            <div flex column style="gap: 8px;">
                              <div flex align-center style="gap: 8px;">
                                <material-icon icon="rule"></material-icon>
                                <div style="font-size: 16px; font-weight: 500;">Warn Condition</div>
                              </div>
                              <div>Select whether to use a custom module or use the logic editor</div>
                              <!--Radio buttons for QC Modules instead of of K-Logic Editor-->
                              <paper-radio-group selected="{{item.check_type}}">
                                <paper-radio-button name="logicEditor" aria-checked="true">Logic Editor</paper-radio-button>
                                <paper-radio-button name="logicModules">Logic Module</paper-radio-button>
                              </paper-radio-group>
                              <template is="dom-if" if="[[equal(item.check_type, 'logicEditor')]]">
                                <div>
                                  Logical statement resulting in <b>True</b> if this QC warning should apply to the given entity (and false
                                  otherwise).
                                </div>
                                <k-logic-editor
                                  id="editor"
                                  schema="[[computeSchema(item.entrypoint)]]"
                                  k-logic-type="[[getKLogicTypeForItem(item, warningsArray.*)]]"
                                  debug-reference-data="[[debugReferenceData]]"
                                  block="{{item.expression}}"
                                ></k-logic-editor>
                              </template>
                              <template is="dom-if" if="[[equal(item.check_type, 'logicModules')]]">
                                <katapult-drop-down
                                  items="[[customModules]]"
                                  label-path="label"
                                  label="Warning Module"
                                  style="width: fit-content;"
                                  value-path="module"
                                  on-selected-changed="updateProperty"
                                  data-path="warningsArray.$(model.warningIndex).qc_module"
                                  value="{{item.module}}"
                                ></katapult-drop-down>
                                <paper-checkbox on-checked="item.custom_text" on-checked-changed="customText"
                                  >Warning Text from Module</paper-checkbox
                                >
                              </template>
                            </div>
                          </div>
                        </template>
                      </div>
                    </paper-header-content>
                  </template>
                </template>

                <template is="dom-if" if="[[equal(selectedTableIndex, 1)]]">
                  <!-- No Warnings -->
                  <template is="dom-if" if="[[!variableCount]]">
                    <paper-row slot="before">
                      <paper-cell center style="color: var(--paper-grey-600);">
                        <iron-icon icon="katapult-misc:search-off"></iron-icon>
                        <span>No Warning Variables Yet</span>
                      </paper-cell>
                    </paper-row>
                  </template>
                  <template
                    is="dom-repeat"
                    items="{{warningVariablesArray}}"
                    index-as="warningIndex"
                    rendered-item-count="{{variableCount}}"
                  >
                    <paper-header-content
                      white
                      opened="{{item.$opened}}"
                      no-click-row
                      slot="sortable"
                      divider
                      data-path="warningVariablesArray.$(model.warningIndex).$rendered"
                      data-value="$true"
                      on-opened-changed="updateProperty"
                    >
                      <!--HEADER ROW-->
                      <paper-cell drag-handle icon slot="header">
                        <span></span>
                      </paper-cell>
                      <paper-cell slot="header">
                        <paper-input label="Variable Name" value="{{item.variable}}" no-label-float></paper-input>
                      </paper-cell>
                      <paper-cell icon-button slot="header-end" on-click="duplicateWarning">
                        <katapult-button iconOnly noBorder icon="content_copy"></katapult-button>
                      </paper-cell>
                      <paper-cell icon-button slot="header-end" on-click="deleteWarningVariable">
                        <katapult-button iconOnly noBorder icon="delete"></katapult-button>
                      </paper-cell>

                      <!--CONTENT ROW-->
                      <div style="background: var(--paper-grey-50); padding: 24px;" slot="content">
                        <template is="dom-if" if="[[item.$rendered]]">
                          <div flex column style="gap: 24px;">
                            <div flex column style="gap: 8px;">
                              <div flex align-center style="gap: 8px;">
                                <material-icon icon="input"></material-icon>
                                <div style="font-size: 16px; font-weight: 500;">Warning Type</div>
                              </div>
                              <div>
                                What part of a job (entity type) does this variable apply to? It has to match your warning entity type.
                              </div>
                              <katapult-drop-down
                                items="[[entrypointsList]]"
                                label-path="label"
                                value-path="name"
                                label="Applies to"
                                style="width: fit-content;"
                                no-label-float
                                sort="[[sortByOrder]]"
                                value="[[item.entrypoint]]"
                                data-path="warningVariablesArray.$(model.warningIndex).entrypoint"
                                on-selected-changed="updateProperty"
                              ></katapult-drop-down>
                            </div>
                            <!-- QC Check -->
                            <div flex column style="gap: 8px;">
                              <div flex align-center style="gap: 8px;">
                                <material-icon icon="data_object"></material-icon>
                                <div style="font-size: 16px; font-weight: 500;">Variable Logic</div>
                              </div>
                              <div>Logical statement to compute variable for warning message.</div>
                              <k-logic-editor
                                id="editor"
                                schema="[[computeSchema(item.entrypoint)]]"
                                k-logic-type="[[getKLogicTypeForItem(item, warningVariablesArray.*)]]"
                                debug-reference-data="[[debugReferenceData]]"
                                block="{{item.expression}}"
                              ></k-logic-editor>
                            </div>
                          </div>
                        </template>
                      </div>
                    </paper-header-content>
                  </template>
                </template>
              </paper-table-scroll>

              <template is="dom-if" if="[[equal(selectedTableIndex, 0)]]">
                <paper-row ripple short on-click="addWarning">
                  <paper-cell center pointer style="color: var(--paper-grey-600);">
                    <span>ADD WARNING</span>
                    <iron-icon style="margin-left: 8px;" icon="add-circle-outline"></iron-icon>
                  </paper-cell>
                </paper-row>
              </template>

              <template is="dom-if" if="[[equal(selectedTableIndex, 1)]]">
                <paper-row ripple short on-click="addWarningVariable">
                  <paper-cell center pointer style="color: var(--paper-grey-600);">
                    <span>ADD WARNING VARIABLE</span>
                    <iron-icon style="margin-left: 8px;" icon="add-circle-outline"></iron-icon>
                  </paper-cell>
                </paper-row>
              </template>
            </paper-table>
          </template>
        </katapult-editor-step>
      </template>

      <confirm-dialog id="changeWarningDialog">
        <div slot="confirm-body">
          <template is="dom-if" if="[[equal('deleting_warning', dialogWarning)]]">
            <div style="margin-bottom: 16px;">Are you sure you want to delete this warning?</div>
          </template>
          <template is="dom-if" if="[[equal('deleting_warning_variable', dialogWarning)]]">
            <div style="margin-bottom: 16px;">Are you sure you want to delete this warning variable?</div>
          </template>
        </div>
      </confirm-dialog>

      ${super.createItemContainer}
    `;
  }

  static get properties() {
    return {
      entrypointsList: {
        type: Array,
        value: () => [
          {
            label: 'Job',
            name: 'job',
            order: 1
          },
          {
            label: 'Nodes',
            name: 'nodes',
            order: 2
          },
          {
            label: 'Connections',
            name: 'connections',
            order: 3
          },
          {
            label: 'Sections',
            name: 'sections',
            order: 4
          },
          {
            label: 'Markers',
            name: 'markers',
            order: 5
          }
        ]
      },
      warningsArray: {
        type: Array,
        computed: 'computeWarningsArray(_itemData.warnings)'
      },
      warningVariablesArray: {
        type: Array,
        computed: 'computeWarningVariablesArray(_itemData.warning_variables)'
      },
      selectedTableIndex: {
        type: Number,
        value: 0
      },
      debugReferenceData: {
        type: Object,
        value: () => ({})
      }
    };
  }

  static get observers() {
    return [
      'warningsArrayChanged(warningsArray.*)',
      'warningVariablesArrayChanged(warningVariablesArray.*)',
      'setupDebugReferenceData(userGroup)'
    ];
  }

  constructor() {
    super();
    this.sortByOrder = (a, b) => a.order - b.order;
  }

  ready() {
    super.ready();

    this.keyMatchLabel = true;

    // An ordered list of all possible steps.
    this.setSteps([
      {
        id: 'logic_editor',
        title: 'Add Warnings and Associated Logic for this QC Module',
        trigger: () => this.get('_itemData.warnings.0.warning_text') != null
      }
    ]);
  }

  warningsArrayChanged(changeRecord) {
    if (changeRecord.path?.includes('warningsArray')) {
      // setup data to notify the element that there are changes
      let lazy = new LazySet(this);
      // Strip any slashes from data_path
      this.warningsArray = this.warningsArray.map((x) => {
        return x;
      });
      lazy.set('_itemData.warnings', this.warningsArray);
      // notify the element that there are changes
      lazy.notify();
    }
  }

  async warningVariablesArrayChanged(changeRecord) {
    if (changeRecord.path?.includes('warningVariablesArray')) {
      let lazy = new LazySet(this);
      // Strip any slashes from data_path
      this.warningVariablesArray = this.warningVariablesArray.map((x) => {
        return x;
      });
      lazy.set('_itemData.warning_variables', this.warningVariablesArray);
      // notify the element that there are changes
      lazy.notify();
    }
  }

  computeWarningsArray() {
    return this._itemData?.warnings || [];
  }

  computeWarningVariablesArray() {
    return this._itemData?.warning_variables || [];
  }

  toggleExpandAll(e) {
    let allExpanded = this.warningsArray.filter((warning) => warning.$opened).length == this.warningsCount;
    for (const key in this.warningsArray) this.set(`warningsArray.${key}.$opened`, !allExpanded);
  }

  warningsArraySorted(e) {
    // Make a copy of warnings array and mutate it as per the sort
    let warningsArrayCopy = this.warningsArray.slice();
    let removedItemsCopy = warningsArrayCopy.splice(e.detail.prevIndex, 1);
    warningsArrayCopy.splice(e.detail.index, 0, removedItemsCopy[0]);
    let movedItems = [];
    // Depending on whether the warning is being moved forward or back, rearrange the relevant portion of warningsArray
    if (e.detail.prevIndex > e.detail.index)
      movedItems = [this.warningsArray[e.detail.prevIndex], ...this.warningsArray.slice(e.detail.index, e.detail.prevIndex)];
    else movedItems = [...this.warningsArray.slice(e.detail.prevIndex + 1, e.detail.index + 1), this.warningsArray[e.detail.prevIndex]];
    // Splice in the rearranged array and reorder the warnings
    this.splice(`warningsArray`, Math.min(e.detail.index, e.detail.prevIndex), movedItems.length, ...movedItems);
    this.reorderWarnings();
  }

  addWarning(e) {
    let order = this.warningsCount + 1;
    this.splice('warningsArray', this.warningsCount, 0, {
      uid: FirebaseWorker.ref().push().key,
      warning_text: '',
      order: order,
      expression: ''
    });
  }

  addWarningVariable(e) {
    let order = this.variableCount + 1;
    this.splice('warningVariablesArray', this.variableCount, 0, {
      uid: FirebaseWorker.ref().push().key,
      variable: '',
      order: order,
      expression: ''
    });
  }

  duplicateWarning(e) {
    // Make a copy of the warning to duplicate
    let duplicateWarning = JSON.parse(JSON.stringify(this.warningsArray[e.model.warningIndex]));
    duplicateWarning.warning_text = `(Copy) ${duplicateWarning.warning_text}`;
    // Reorder the warnings
    this.splice('warningsArray', e.model.warningIndex + 1, 0, duplicateWarning);
    this.reorderWarnings();
  }

  duplicateWarningVariable(e) {
    // Make a copy of the warning to duplicate
    let duplicateWarningVariable = JSON.parse(JSON.stringify(this.warningVariablesArray[e.model.warningIndex]));
    duplicateWarningVariable.variable = `(Copy) ${duplicateWarningVariable.variable}`;
    // Reorder the warnings
    this.splice('warningVariablesArray', e.model.warningIndex + 1, 0, duplicateWarningVariable);
    this.reorderWarnings();
  }

  deleteWarning(e) {
    // Make a copy of warnings array and mutate it as per the delete
    let warningsArrayCopy = this.warningsArray.slice();
    warningsArrayCopy.splice(e.model.warningIndex, 1);
    let commitDelete = () => {
      // Delete the warning and reorder the other warnings
      this.splice('warningsArray', e.model.warningIndex, 1);
      this.reorderWarnings();
    };
    // Show the delete confirm message
    this.set(`dialogWarning`, 'deleting_warning');
    this.$.changeWarningDialog.callback = commitDelete;
    this.$.changeWarningDialog.openSlotted('Confirm Delete');
  }

  deleteWarningVariable(e) {
    // Make a copy of warnings array and mutate it as per the delete
    let warningVariablesArrayCopy = this.warningVariablesArray.slice();
    warningVariablesArrayCopy.splice(e.model.warningIndex, 1);
    let commitDelete = () => {
      // Delete the warning and reorder the other warnings
      this.splice('warningVariablesArray', e.model.warningIndex, 1);
      this.reorderWarnings();
    };
    // Show the delete confirm message
    this.set(`dialogWarning`, 'deleting_warning_variable');
    this.$.changeWarningDialog.callback = commitDelete;
    this.$.changeWarningDialog.openSlotted('Confirm Delete');
  }

  reorderWarnings() {
    for (const key in this.warningsArray) {
      this.set(`warningsArray.${key}.order`, parseInt(key, 10) + 1);
    }
  }

  reorderWarningVariables() {
    for (const key in this.warningVariablesArray) {
      this.set(`warningVariablesArray.${key}.order`, parseInt(key, 10) + 1);
    }
  }

  customText(e) {
    if (e.detail.value) {
      this.set(
        `warningsArray.${e.model.warningIndex}.warning_text`,
        this.customModules.find((module) => module.module === e.model.item.module).label
      );
      this.set(`warningsArray.${e.model.warningIndex}.custom_text`, true);
    }
  }

  computeSchema(entrypoint) {
    if (entrypoint == null) return {};
    const isPpl = config.appName == 'ppl-kws';

    const commonData = {
      job: DEFAULT_SCHEMAS.JOB,
      connection_lookup: DEFAULT_SCHEMAS.CONNECTION_LOOKUP,
      marker_lookup: DEFAULT_SCHEMAS.MARKER_LOOKUP,
      ...(isPpl && { cu_lookup: PPL_SCHEMAS.CU_LOOKUP })
    };

    switch (entrypoint) {
      case 'job':
        return commonData;
      case 'nodes':
        return {
          node: DEFAULT_SCHEMAS.NODE,
          node_id: 'text',
          main_photo: DEFAULT_SCHEMAS.PHOTO,
          main_photo_id: 'text',
          ...(isPpl && { compatible_units: { $wild: PPL_SCHEMAS.COMPATIBLE_UNIT } }),
          ...commonData
        };
      case 'connections':
        return {
          connection: DEFAULT_SCHEMAS.CONNECTION,
          connection_id: 'text',
          ...commonData
        };
      case 'sections':
        return {
          section: DEFAULT_SCHEMAS.SECTION,
          section_id: 'text',
          connection: DEFAULT_SCHEMAS.CONNECTION,
          connection_id: 'text',
          main_photo: DEFAULT_SCHEMAS.PHOTO,
          main_photo_id: 'text',
          ...commonData
        };
      case 'markers':
        return {
          marker: DEFAULT_SCHEMAS.MARKER_LOOKUP,
          main_photo: DEFAULT_SCHEMAS.PHOTO,
          main_photo_id: 'text',
          ...commonData
        };
    }
  }

  async setupDebugReferenceData() {
    // get the current model key
    if (!this.userGroup) return;

    // get the list of jobs for the model from job permissions
    const jobs = await FirebaseWorker.ref(`photoheight/job_permissions/${this.userGroup}/list`)
      .once('value')
      .then((s) => s.val());
    if (!jobs || jobs.length == 0) return;

    // set the dataset for reference in k-logic
    this.debugReferenceData = { jobs, appName: config.appName };
  }

  getKLogicTypeForItem(item) {
    if (!item) return null;
    switch (item.entrypoint) {
      case 'job':
        return 'JOB_QC';
      case 'nodes':
        return 'NODE_QC';
      case 'connections':
        return 'CONNECTION_QC';
      case 'sections':
        return 'SECTION_QC';
      case 'markers':
        return 'MARKER_QC';
      default:
        return null;
    }
  }
}

customElements.define('katapult-quality-control-editor', KatapultQualityControlEditor);
